var _excluded = ["items", "spacing", "itemPadding", "divider", "utils", "id"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import generateID from './../../utilities/generateID';
import StyledVerticalList from './vertical-list.styles';
var verticalListPropTypes = {
  /** ID of the component in order to put an unique identifier for the unordered list */
  id: PropTypes.string,
  /** An array of items that to be rendered as a list. */
  items: PropTypes.arrayOf(PropTypes.node),
  /** The amount of spacing between each list item. accepts a values 2-10. */
  spacing: PropTypes.oneOf(['', '2', '3', '4', '5', '6', '7', '8', '9', '10']),
  /** Adds horizontal padding list item. */
  itemPadding: PropTypes.oneOf(['', 'xs', 'sm', 'lg', 'xl', 'gi']),
  /** Adds a divider to a list item. */
  divider: PropTypes.oneOf(['none', 'default', 'top', 'bottom']),
  /** Add utility props for styling */
  utils: PropTypes.object
};
var verticalListDefaultProps = {
  id: '',
  items: [/*#__PURE__*/React.createElement(React.Fragment, null)],
  divider: 'default',
  itemPadding: '',
  spacing: '',
  utils: {}
};

/**
 * @ignore @description
 * ## VerticalList
 * The VerticalList layout component provides vertical rhythm to its children.
 *
 * @ignore @see Mesh: [VerticalList Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/scaffolding-verticallist--default)
 *
 * @ignore @example
 * ```jsx
 * import { VerticalList, Box } from 'mesh-component-library';
 *
 * <VerticalList
 *  items={[
 *  <Box>
 *    <code>Item 1</code>
 *  </Box>,
 *  <Box>
 *    <code>Item 2</code>
 *  </Box>,
 *  <Box>
 *    <code>Item 3</code>
 *  </Box>
 *  ]}
 * />;
 * ```
 */

var VerticalList = function VerticalList(props) {
  var items = props.items,
    spacing = props.spacing,
    itemPadding = props.itemPadding,
    divider = props.divider,
    utils = props.utils,
    id = props.id,
    other = _objectWithoutProperties(props, _excluded);
  var useId = id || generateID('vertical-list-');
  return /*#__PURE__*/React.createElement(StyledVerticalList, _extends({
    id: useId,
    spacing: spacing,
    divider: divider,
    itemPadding: itemPadding,
    utils: utils
  }, other), items.map(function (item, i) {
    var itemId = item.props.id;
    return /*#__PURE__*/React.createElement("li", {
      key: itemId || "".concat(useId, "-key-").concat(i)
    }, " ", item, " ");
  }));
};
VerticalList.propTypes = verticalListPropTypes;
VerticalList.defaultProps = verticalListDefaultProps;
export default VerticalList;